<template>
  <div class="wrapper">
    <div class="list" v-if="isShow">
        <img class="title" src="http://img.tutubox.cn/bcbTitle-1.png">
        <div class="name">珠宝区块链鉴定书</div>
        <img :src="thumbnail" class="thumbnail">
      <table class="table table-striped">
        <tbody>
          <tr>
            <td>作品名称</td>
            <td>{{searchResult.name}}</td>
          </tr>
          <tr>
            <td>签名</td>
            <td>{{searchResult.signature}}</td>
          </tr>
          <tr>
            <td>Hash</td>
            <td>{{searchResult.hash}}</td>
          </tr>
          <tr>
            <td>Block</td>
            <td>{{searchResult.block}}</td>
          </tr>
          <tr>
            <td>作者名称</td>
            <td>{{searchResult.author}}</td>
          </tr>
          <tr>
            <td>头像</td>
            <td>
              <img :src="avatar" alt width="50" height="50">
            </td>
          </tr>
          <!-- <tr>
            <td>作品预览</td>
            <td>
              <img :src="thumbnail" alt width="60" height="60">
            </td>
          </tr> -->
          <tr>
            <td>模型浏览</td>
            <td>
              <button @click="previewModle">模型浏览</button>
            </td>
          </tr>
          <tr>
            <td>邮箱</td>
            <td>{{searchResult.email}}</td>
          </tr>
          <tr>
            <td>创作时间</td>
            <td>{{searchResult.createTime}}</td>
          </tr>
          <tr>
            <td>发布时间</td>
            <td>{{searchResult.publishedTime}}</td>
          </tr>
          <tr>
            <td>Size</td>
            <td>{{searchResult.size}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      searchResult: {},
      isShow: false
    };
  },
  computed: {
    avatar: function() {
      return this.searchResult.baseUrl + this.searchResult.avatar;
    },
    thumbnail: function() {
      return this.searchResult.baseUrl + this.searchResult.thumbnail;
    }
  },
  created() {
    axios
      .get(`/api/bcb/inquire/${this.$route.params.id}`)
      .then(res => {
        this.searchResult = res.data;
        this.isShow = true;
      })
      .catch(() => {
        alert("查询失败");
        this.isShow = false;
        this.$router.go(-1)
      });
    // this.searchResult = this.$route.params.result
  },
  methods: {
    previewModle() {
      var el = document.createElement("a");
      document.body.appendChild(el);
      el.href = `http://3d.gemtec.ltd/3d-box.html?model=${
        this.searchResult.model
      }`;
      el.target = "_blank";
      el.click();
      document.body.removeChild(el);
    }
  }
};
</script>

<style scoped>

.wrapper{
    width: 100vw;
    height: 100vh;
}

.list {
    position: relative;
  margin: 0 auto;
width: 50%;
    /* width: 500px; */
    /* height: 880px; */
  padding-top: 60px;
  padding-bottom: 110px;
  font-size: 14px;
  color: #5f5f5f;
  background: url("http://img.tutubox.cn/bcbBroBg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
@media screen and (max-width: 1000px) {
  .list {
    width: 100%;
  }
}
.title{
    width: 25%;
    left: 50%;
    position: relative;
    transform: translateX(-50%);
}
.name{
  text-align: center;
  margin-top: 50px;
  margin-bottom: 10px;
  color: #8869a9;
}
.thumbnail{
    left: 50%;
    position: relative;
    transform: translateX(-50%);
}
.table {
  margin: 0 auto;
}
.table-striped tr:nth-of-type(odd) {
  background-color: #fff;
}
.table tr {
  height: 35px;
  line-height: 35px;
  border-bottom: 1px solid grey;
}
.table td {
  padding: 10px;
}
</style>